import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FindTaskComponent } from './find-task.component';

const routes: Routes = [{ path: '', component: FindTaskComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FindTaskRoutingModule {}
